import { Suspense, useRef } from "react"
import { v4 as uuid } from "uuid"

import { ErrorBoundary, Icon } from "web/components"
import useDropDownMenu from "web/hooks/behaviour/useDropDownMenu"

import ValueInfo from "./ValueInfo"

export default function InfoIcon({ fieldKey }) {
  const { current: valueId } = useRef(uuid())

  const { DropDownMenu, menuVisible, toggleMenu } = useDropDownMenu({
    triggerElementId: `infoIcon_${valueId}`,
  })

  return (
    <>
      <div id={`infoIcon_${valueId}`} className="text-neutral-6">
        <Icon
          outline
          name="information-circle"
          width="20px"
          height="20px"
          className="ml-1 cursor-pointer"
          onClick={toggleMenu}
        />
      </div>
      {menuVisible && (
        <DropDownMenu transition={false}>
          <div className="value-view-tool-tip p-2.5 text-left text-sm">
            <ErrorBoundary fallback={<div>Failed to load info.</div>}>
              <Suspense fallback={<div>Getting value info...</div>}>
                <ValueInfo fieldKey={fieldKey} />
              </Suspense>
            </ErrorBoundary>
          </div>
        </DropDownMenu>
      )}
    </>
  )
}
